import {$qs} from '../../@shared/ts/dom';

function relatedProductsToggleUI() {
	const relatedProductsToggle = $qs<HTMLInputElement>('#peachpay_related_products_toggle');
	const autoSlideToggle = $qs<HTMLInputElement>('#peachpay_related_slider_toggle');

	if (!relatedProductsToggle || !autoSlideToggle) {
		return;
	}

	relatedProductsToggle.addEventListener('change', event => {
		if ((event.target as HTMLInputElement).checked && autoSlideToggle.disabled) {
			autoSlideToggle.disabled = false;
		} else if (!(event.target as HTMLInputElement).checked) {
			autoSlideToggle.checked = false;
			autoSlideToggle.disabled = true;
		}
	});
}

export {relatedProductsToggleUI};
